import React, { useLayoutEffect, useRef } from "react";
import * as coverStyles from "./Cover.module.scss";
import { FadeInUPTextAnimation } from "../../../../../GSAPSnippets";

import { gsap } from "gsap";

const Cover = () => {
  const TAVectorRef = useRef();

  useLayoutEffect(() => {
    FadeInUPTextAnimation("TAText-wrapper", 1.2);

    TAVectorRef.current.style.strokeDasharray =
      TAVectorRef.current.getTotalLength();

    gsap.fromTo(
      TAVectorRef.current,
      {
        strokeDashoffset: TAVectorRef.current.getTotalLength() + 4,
      },
      {
        delay: 1.5,
        duration: 1.3,
        strokeDashoffset: 0,
      }
    );
  });

  const subtitleString =
    "Find Your Missing Puzzle Pieces With Our Team Augmentation";
  const titleString = `We find perfectly fitting technologists to suit your daily operations. Retain full project ownership and management while employing top-notch field specialists.`;

  return (
    <section
      className={`es-section__light team-augmentation-section ${coverStyles.coverSection}`}
    >
      <div>
        <div className="TAText-wrapper">
          <span className={`es-subtitle-text`}>{subtitleString}</span>
          <h2>{titleString}</h2>
        </div>

        <div className={coverStyles.coverVector}>
          <svg
            width="924"
            height="520"
            viewBox="0 0 924 520"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              ref={TAVectorRef}
              d="M331.616 456.434C316.325 473.812 301.034 491.189 275.972 503.06C250.91 514.93 216.076 521.275 182.565 516.284C149.053 511.294 116.881 494.897 88.9429 470.033C61.0047 445.17 37.3179 411.752 21.9197 367.319C6.52146 322.886 -0.48097 267.635 2.78802 219.673C6.05701 171.711 19.9547 131.146 39.8366 98.4759C59.7185 65.8062 85.6739 40.8718 115.881 24.5993C146.088 8.32684 180.51 0.645097 211.343 2.1957C242.175 3.74631 269.381 14.5293 293.371 32.1385C317.362 49.7477 338.137 74.1831 354.106 104.696C370.076 135.209 381.294 171.764 384.563 213.524C387.832 255.283 383.17 302.211 372.774 338.98C362.377 375.749 346.211 402.377 327.704 423.907C309.198 445.438 288.298 461.781 258.162 468.911C240.259 473.217 221.639 473.648 203.555 470.174C185.471 466.7 168.343 459.402 153.322 448.771C117.935 423.729 86.4957 375.821 72.0621 324.758C57.6285 273.695 60.2544 219.477 70.9724 178.395C81.6904 137.312 100.84 109.384 122.919 89.2792C144.998 69.1748 170.132 56.8056 197.695 55.255C225.258 53.7044 255.251 62.9545 280.045 79.4765C304.839 95.9985 324.435 119.828 337.44 148.113C350.444 176.398 356.84 209.139 355.518 245.427C354.196 281.715 345.157 321.567 330.42 350.708C315.682 379.849 295.247 398.331 270.667 405.354C246.087 412.376 217.363 407.974 193.747 392.557C170.132 377.14 151.59 350.672 141.943 316.844C132.297 283.016 131.672 241.827 139.871 209.193C148.071 176.559 165.148 152.48 185.119 138.186C205.09 123.892 227.991 119.418 248.873 124.943C269.756 130.468 288.762 146.064 301.928 165.419C315.093 184.775 322.47 207.945 323.524 235.714C324.578 263.482 319.273 295.849 305.536 320.338C291.799 344.826 269.506 361.473 249.534 361.331C229.563 361.188 211.896 344.452 201.303 322.245C190.71 300.037 187.12 272.34 190.175 247.388C193.229 222.435 202.875 199.782 217.452 188.072C232.028 176.363 251.499 175.596 266.272 186.165C281.045 196.735 291.174 218.461 292.657 240.775C294.139 263.09 287.012 285.868 278.044 296.847C269.077 307.826 258.395 306.97 250.481 301.249C242.568 295.528 237.816 284.941 236.834 275.227C235.851 265.514 238.745 256.709 242.3 252.218C245.855 247.726 250.124 247.548 252.75 250.596C255.376 253.644 256.412 259.935 256.912 263.232C257.412 266.53 257.43 266.797 257.484 267.047C257.537 267.296 257.662 267.243 266.915 268.312L303.785 272.518C313.003 273.57 313.003 273.57 340.977 276.35C368.951 279.131 424.935 284.674 456.803 287.703C488.671 290.733 496.567 291.268 501.265 292.017C504.429 292.264 507.415 293.577 509.732 295.742C511.983 297.702 514.966 300.572 518.664 303.869C522.361 307.166 526.666 310.856 542.333 313.547C557.999 316.238 585.026 317.931 600.549 319.054C616.072 320.177 620.11 320.837 619.788 318.591C619.466 316.345 614.804 311.462 611.124 307.647C607.444 303.833 604.729 301.374 605.086 297.952C605.444 294.53 608.659 289.914 612.107 286.616C615.554 283.319 618.931 281.269 607.462 279.487C595.994 277.705 569.663 276.297 554.265 276.386C538.867 276.475 534.455 278.168 530.221 280.467C525.988 282.766 521.95 286.01 518.592 288.327C515.234 290.644 512.519 292.159 527.327 294.013C542.136 295.866 574.397 298.076 592.922 299.36C611.446 300.643 616.144 301.142 623.557 288.844C630.97 276.546 640.849 251.665 658.051 248.368C675.254 245.071 699.726 263.375 716.286 282.945C732.845 302.514 741.527 323.385 753.924 328.055C766.321 332.725 782.505 321.175 796.582 303.21C810.658 285.244 822.751 260.826 834.738 261.593C846.724 262.359 858.603 288.327 867.785 305.33C876.967 322.334 883.415 330.514 891.99 328.394C900.564 326.273 911.282 313.886 922 301.516"
              stroke="url(#paint0_linear_967_78)"
              strokeWidth="2.75"
              strokeMiterlimit="2.61"
              strokeLinecap="round"
            />
            <defs>
              <linearGradient
                id="paint0_linear_967_78"
                x1="72.3825"
                y1="30.2481"
                x2="837.69"
                y2="80.6539"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="0.197816" stopColor="#0066CC" />
                <stop offset="0.513542" stopColor="#EB3300" />
                <stop offset="1" stopColor="#EB8D00" />
              </linearGradient>
            </defs>
          </svg>
        </div>
      </div>
    </section>
  );
};

export default Cover;
